import { LOGO_VIEWBOX, LOGO_WORD, LOGO_CAPTION, LOGO_CORNER } from "@/components/logoPaths";

export function LogoSvg({ className = "", word = "#FFFFFF", caption = "#D4AF37", corner = "#F0A31E", ...rest }) {
  return (
    <svg viewBox={LOGO_VIEWBOX} className={className} aria-hidden="true" focusable="false" {...rest}>
      <path d={LOGO_WORD} fill={word} />
      <path d={LOGO_CAPTION} fill={caption} />
      {LOGO_CORNER.map(([x, y, w, h]) => (
        <rect key={`${x}-${y}`} x={x} y={y} width={w} height={h} fill={corner} />
      ))}
    </svg>
  );
}

export default function Logo({ size = "md" }) {
  const h = size === "lg" ? "h-14" : "h-10 sm:h-12";
  return (
    <span className="inline-flex items-center">
      <LogoSvg className={`${h} w-auto`} />
    </span>
  );
}
